"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableCssClasses;
(function (TableCssClasses) {
    TableCssClasses["GENERIC"] = "table-generic";
    TableCssClasses["GENERIC_FIXED"] = "table-generic-fixed";
    TableCssClasses["SELECTABLE"] = "table-selectable";
    TableCssClasses["STRIPED"] = "table-striped";
})(TableCssClasses || (TableCssClasses = {}));
exports.default = TableCssClasses;
//# sourceMappingURL=TableCssClasses.js.map